import { GeoZone } from "../geoZone";
import { Integration } from "../integration";

/**
 * IntegrationDeliveryZone types
 * Define las zonas de entrega permitidas para cada integración de fulfillment provider.
 */

export interface IntegrationDeliveryZone {
    id: string;
    integrationId: string;
    geoZoneId: string;
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date | null;

    // Relations
    integration?: Integration;
    geoZone?: GeoZone;
}

export enum IntegrationDeliveryZoneStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}